<template>
  <!-- table区域-begin -->
  <div class="table-container">
    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      class="j-table-force-nowrap"
      :scroll="{ x: true }"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">打分</a>
      </span>
    </a-table>

    <okr-plan-revise-markacilitator-modal
      ref="modalForm"
      @ok="modalFormOk"
      :mainId="mainId"
    ></okr-plan-revise-markacilitator-modal>
  </div>
</template>


<script>
import Vue from 'vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import OkrPlanReviseMarkacilitatorModal from './OkrPlanReviseMarkacilitatorModal.vue'

export default Vue.extend({
  name: 'MarkTableFacilitatorList',
  mixins: [JeecgListMixin],
  components: { OkrPlanReviseMarkacilitatorModal },
  props: {
    queryModel: {
      type: Object,
      default: {},
      required: false,
    },
    mainId: {
      type: String,
      default: '',
      required: false,
    },
    mainRow: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      model: {},
      // 表头
      columns: [
        {
          title: '用户',
          align: 'center',
          dataIndex: 'createByDictText',
        },
        {
          title: '工作计划',
          align: 'center',
          dataIndex: 'content',
        },
        {
          title: '权重',
          align: 'center',
          dataIndex: 'weight',
        },
        {
          title: '虚线汇报对象',
          align: 'center',
          dataIndex: 'facilitatorsText',
        },
        {
          title: '分',
          align: 'center',
          dataIndex: 'facilitatorsScore',
        },
        {
          title: '汇报对象',
          align: 'center',
          dataIndex: 'reporterText',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/listOkrPlanReviseByFacilitator`,
      },
    }
  },
  created() {
    this.filters = { ...this.queryModel }
    this.loadData()
      // 初始化字典配置 在自己页面定义
      this.initDictConfig()
  },
  methods: {
    handleQuery(filters) {
      this.filters = { ...this.queryModel }
      this.loadData()
    },
  },
})
</script>

<style lang="less" scoped>
@import '~@assets/less/common.less';

.table-container /deep/td {
  white-space: pre-wrap;
}
</style>
